var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory = function SvgCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_703_12852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_703_12852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5417 17.334L11.0625 11.8548L12.0208 10.8965L17.5 16.3757L16.5417 17.334ZM4.66667 16.3757C3.93056 15.5701 3.38542 14.6777 3.03125 13.6986C2.67708 12.7194 2.5 11.7229 2.5 10.709C2.5 9.62565 2.70139 8.5701 3.10417 7.54232C3.50694 6.51454 4.11806 5.59093 4.9375 4.77148C5.75694 3.95204 6.68403 3.34093 7.71875 2.93815C8.75347 2.53537 9.8125 2.33398 10.8958 2.33398C11.9097 2.33398 12.9062 2.51107 13.8854 2.86523C14.8646 3.2194 15.75 3.76454 16.5417 4.50065L4.66667 16.3757ZM4.72917 14.5215L6.16667 13.0632C5.94444 12.7576 5.72222 12.4277 5.5 12.0736C5.27778 11.7194 5.07292 11.3444 4.88542 10.9486C4.69792 10.5527 4.54167 10.143 4.41667 9.7194C4.29167 9.29579 4.20833 8.86176 4.16667 8.41732C3.79167 9.4451 3.66319 10.4937 3.78125 11.5632C3.89931 12.6326 4.21528 13.6187 4.72917 14.5215ZM7.16667 12.1257L12.2917 6.95898C11.6528 6.45898 11.0035 6.06662 10.3438 5.7819C9.68403 5.49718 9.05556 5.30968 8.45833 5.2194C7.86111 5.12912 7.32986 5.12912 6.86458 5.2194C6.39931 5.30968 6.04167 5.47982 5.79167 5.72982C5.54167 5.97982 5.38194 6.33746 5.3125 6.80273C5.24306 7.26801 5.26042 7.78885 5.36458 8.36523C5.46875 8.94162 5.67014 9.55273 5.96875 10.1986C6.26736 10.8444 6.66667 11.4868 7.16667 12.1257ZM13.2292 6.00065L14.7292 4.56315C13.8125 3.97982 12.816 3.63954 11.7396 3.54232C10.6632 3.4451 9.61111 3.59787 8.58333 4.00065C9 4.04232 9.41319 4.12565 9.82292 4.25065C10.2326 4.37565 10.6354 4.52496 11.0312 4.69857C11.4271 4.87218 11.809 5.0701 12.1771 5.29232C12.5451 5.51454 12.8958 5.75065 13.2292 6.00065Z",
    fill: "#808080"
  }))));
};
export default SvgCategory;